(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('EditActivityTypesCtrl', ['$http', '$scope', '$timeout', 'Alerts', 'Api', 'ActivityTypes', 'Logger', function ($http, $scope, $timeout, Alerts, Api, ActivityTypes, Logger) {
    // Doing simple list and client-side typeahead because activity type counts
    // are relatively small per org -- typically under 20 and always under 100
    ActivityTypes.list().then(function (data) {
      $scope.activityTypes = data.results;
    });
    $scope.clearSelection = function clearSelection() {
      $scope.selectedActivityType = null;
      $scope.searchTerm = null;
    };
    $scope.selectActivityType = function selectActivityType(item) {
      $scope.selectedActivityType = item;
      $scope.activityTypeToEdit = angular.copy(item);
      delete $scope.success;
    };
    $scope.save = function save(activityType) {
      $http.put(Api.url("/acc/activity-types"), activityType).then(function accountUpdateSuccess() {
        $scope.selectedActivityType = activityType;

        // Update the object in our main list without refreshing server-side
        var existing = _.findWhere($scope.activityTypes, {
          id: activityType.id
        });
        existing.name = activityType.name;
        $scope.success = {
          message: "Activity Type updated successfully.  Cached reports will have to expire or be manually refreshed to reflect changes.",
          activityType: activityType
        };
        $scope.clearSelection();
        loadRecentActivityTypes(activityType);
      }, function accountUpdateFail(response) {
        Logger.error("Update system account failed with response status " + response.status);
        $scope.errorMessage = "There was an error updating the activity type.";
      });
    };
    function loadRecentActivityTypes(editedActivityType) {
      var params = {
        _limit: 10,
        order_by: "-editDate"
      };
      $http.get(Api.url("/acc/activity-types"), {
        params: params
      }).then(function (response) {
        // Filter out results that don't have any edit date
        $scope.recentActivityTypes = _.reject(response.data.results, function (type) {
          return !type.editDate;
        });

        // This ensures that the UI will show the most recent name as it was edited
        // by the user, even if the async part of renaming is still running
        if (editedActivityType) {
          $scope.recentActivityTypes = _.reject($scope.recentActivityTypes, function (type) {
            return type.id === editedActivityType.id;
          });
          $scope.recentActivityTypes.unshift(editedActivityType);
        }
      }, function () {
        $scope.recentActivityTypes = [];
      });
    }
    loadRecentActivityTypes();
  }]);
})();
